import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import * as UserModels  from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as Models from '../../../../../../src/app/models/commonModels';

@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.css']
})

export class TwoFactorAuthenticationComponent implements OnInit {

    @Select(SettingsState.Settings)
    settings$: Observable<Models.Response<SettingsPreview>>;


    public phoneMask = '000-000-000';

    public isTFATelephoneValidationError = false;

    public submittedCodeRequest = false;

    public submittedCode = false;

    public codeRequestProcessing = false;

    public codeVeryficationProcessing = false;

    public codeSend = false;
    
    returnUrl: string;

    codeVerificationRequestError = '';

  public currentUser: UserModels.User;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        public environment: EnvironmentService,
        public store: Store,
    ) {
        // redirect to home if already logged in
      if (this.authenticationService.currentUserValue &&
          this.authenticationService.currentUserValue.Token
         ) {          
            this.router.navigate(['/']);
      }

      if (this.authenticationService.currentUserValue &&
        !this.authenticationService.currentUserValue.TFAToken
      ) {
        this.router.navigate(['/login']);
      }

      if (!this.authenticationService.currentUserValue) {
        this.router.navigate(['/login']);
      }
    }

  ngOnInit() {

    this.authenticationService.currentUser.subscribe((user) => {
      this.currentUser = user;


    });


        this.settings$.subscribe((data) => {
            if (data && data.Success == true) {
                this.environment.settings = data.Item; 
                localStorage.setItem('psSettingsKey', JSON.stringify(data.Item));
            }
        })

        this.returnUrl = '/home';
    }

  TFATelephoneValidation() {

    const value = this.currentUser.TFATelephone;

    if (value) {

      let telephone = value.replace(/\D/g, '');

      let isMatch = telephone.match('^\\d{9}$');

      this.isTFATelephoneValidationError = !isMatch;
    }
    else {
      this.isTFATelephoneValidationError = false;
    }
  }




  onTelSubmit() {

    this.submittedCodeRequest = true;

    this.codeSend = false;

    this.TFATelephoneValidation();

    this.codeRequestProcessing = true;

    this.authenticationService.tfaCodeRequest(this.currentUser)
    .pipe(first())
      .subscribe(

      data => {

          this.codeRequestProcessing = false;

          if (data.TFACodeStatus === UserModels.TFACodeStatusTypes.TokenExpired) {
            this.router.navigate(['/login']);
          }

          if (data.TFACodeStatus === UserModels.TFACodeStatusTypes.OK) {
            this.codeSend = true;
          }
        },
        error => {
          this.codeVerificationRequestError = 'Nieoczekiwany błąd przy generowaniu jednorazowego kodu.';

          this.codeRequestProcessing = false;
        });
  }

  onCodeSubmit() {

    this.TFATelephoneValidation();

    this.codeRequestProcessing = true;

    this.authenticationService.tfaCodeAuthenticate(this.currentUser)
      .pipe(first())
      .subscribe(

        data => {

          this.codeRequestProcessing = false;

          this.IsCodeVerificationRequestError();

          if (this.authenticationService.currentUserValue.Token) {

            this.router.navigate(['/home']);

          }
        },
        error => {
          this.codeVerificationRequestError = 'Nieoczekiwany błąd przy generowaniu jednorazowego kodu.';

          this.codeRequestProcessing = false;
        });
  }

  public IsCodeVerificationAvailable(): boolean
  {
    return this.currentUser &&
      (this.currentUser.TFACodeStatus == UserModels.TFACodeStatusTypes.OK ||
       this.currentUser.TFACodeStatus == UserModels.TFACodeStatusTypes.IncorrectCode ||
       this.currentUser.TFACodeStatus == UserModels.TFACodeStatusTypes.CodeAlreadySend
      );
  }

  public IsCodeVerificationRequestError(): boolean {

    if (this.currentUser &&
        this.currentUser.TFACodeStatus != UserModels.TFACodeStatusTypes.OK &&
        this.currentUser.TFACodeStatus != UserModels.TFACodeStatusTypes.None) {

      this.codeVerificationRequestError = this.currentUser.TFAMessage;

      return true;
    }
    else {

      this.codeVerificationRequestError = "";

      return false;
    }
  }
}
